<template>
  <div class="dialog_warp">
    <div style="background:#fff">
      <div class="demo-ruleForm dialog_form" style="max-height:370px;overflow:auto">
        <div style="text-align:center" v-if="activities.length==0">暂无操作记录</div>
        <el-timeline>
          <el-timeline-item
            v-for="(item, index) in activities"
            :key="index"
            color="#2482FD">
            <div class="time-line-box">
              <div class="time-line-info">
                <div>
                  <i class="el-icon-alarm-clock"></i>
                  {{item.rlTime|datetime}}
                </div>
                <div>
                  <i class="el-icon-user"></i>&nbsp;
                  操作人：{{item.rlPerson}}
                </div>
              </div>
              <div class="time-line-content">
                {{item.rlLog}}
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
      <div class="text-right box-top-sh" style="padding-top:10px;padding-bottom:10px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="filters.pageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :background="true"
          :page-size="filters.pageSize"
          layout="prev, pager, next, sizes"
          :total="filters.total"
        >
        </el-pagination>
      </div>
    </div>
    <div class="text-right">
      <p style="margin-top: 10px">
        <el-button size="small" @click="close">取消</el-button>
        <el-button
          size="small"
          type="success"
          @click="close"
          >确认</el-button
        >
      </p>
    </div>
  </div>
</template>

<script>
import * as getData from "../service/getData";
export default {
  props: ['isEdit','companyId'],
  data() {
    return {
      filters: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
        companyId: 0
      },
      activities: []
    };
  },
  mounted() {
    this.filters.companyId = this.companyId
    this.init()
  },
  methods: {
    close() {
      this.$emit("closeDialog");
    },
    init(){
      getData.operationRecord(this.filters).then(res => {
        if(res.data.code === 1){
          this.activities = res.data.data.list;
          this.filters.total = res.data.data.total;
        }else{
          this.$message.error(res.data.message)
        }
      })
    },
    handleSizeChange(val) {
      this.filters.pageIndex = 1
      this.init()
    },
    handleCurrentChange(val) {
      this.filters.pageIndex = val
      this.init()
    }
  },
};
</script>

<style lang="scss" scoped>
.dialog_form{
  padding: 30px 40px;
}
.time-line-box{
  width: 480px;
}
.time-line-info{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: #868686;
}
.time-line-content{
  width: 100%;
  // height: 70px;
  padding: 18px 0;
  text-indent: 2em;
  background: #fff;
  border: 1px solid #e4e4e4;
  margin-top: 10px;
  border-radius: 8px;
  box-shadow: 0px 0px 20px -5px #d8d8d8;
}
.box-top-sh{
  box-shadow: 0px 0px 10px 1px rgb(233, 233, 233);
}
</style>


// WEBPACK FOOTER //
// src/components/checkChangeRecords.vue